const VIEWS = {
    UPDATE: "UPDATE"
};

export default {
    VIEWS
};
